<script lang="ts">
  /* Saved trips. The store is chart-core's; this only says what "open" means. */
  import TripsPanelUI from '@gennetay/chart-ui/panels/TripsPanel';
  import { panels } from '@gennetay/chart-ui/shell';
  import { autoroute } from '@gennetay/chart-core/lib/autoroute.svelte';
  import { editor } from '@gennetay/chart-core/lib/editor.svelte';
  import { routePlan } from '@gennetay/chart-core/lib/routeplan.svelte';
  import { resolveRoute } from '../route.svelte';
  import { fitTo } from '../camera.svelte';
</script>

<TripsPanelUI
  onopen={(t) => {
    /* The trip stores the QUESTION, so opening it means asking the router
       again rather than restoring a picture. A stored schedule states a slack
       to the minute and goes stale silently. */
    autoroute.departT = t.departT;
    autoroute.setBoatKn(t.boatKn);
    autoroute.setUseCurrents(t.useCurrents);
    routePlan.start = { lat: t.points[0]!.lat, lon: t.points[0]!.lon };
    routePlan.end = {
      lat: t.points[t.points.length - 1]!.lat,
      lon: t.points[t.points.length - 1]!.lon
    };
    editor.startDraft(t.points.map((p) => ({ lat: p.lat, lon: p.lon })));
    fitTo(t.points);
    void resolveRoute();
    panels.show('trip');
  }}
/>
